import { NzModalService } from 'ng-zorro-antd/modal';
import { CanComponentDeactivate } from './../../../shared/guard/can-deactivate-guard.service';
import { Component, OnInit, OnDestroy, AfterViewInit, Input, Renderer2, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateService } from '@root/shared/service/translate.service';
import { ChannelHouseService } from '../channel-house/channel-house.service';

@Component({
  selector: 'host-house-relation',
  templateUrl: './house-relation.component.html',
  styleUrls: ['./house-relation.component.scss'],
})
export class HouseRelationComponent implements OnInit, CanComponentDeactivate {
  constructor(private t: TranslateService, private modal: NzModalService, private channelSrv: ChannelHouseService) {}

  ngOnInit() {}

  ngAfterViewInit() {}

  /** @depreacted */
  canDeactivate(): Observable<boolean> {
    return this.channelSrv.displaySyncListingWarning();
  }
}
